import { FuelPurchaseModule, fuelPurchaseModuleName } from './modules/fuel-purchases/fuel-purchases';
import { FilterModule, filterStoreModuleName } from '@/store/modules/filters/filters-store';
import { MessagingModule, messagingStoreModuleName } from '@/store/modules/messaging/messaging-store';
import { UserDetailsModule, userSettingsStoreModuleName } from '@/store/modules/user-settings/user-settings-store';
import { createStore } from 'vuex';
import { getModule } from 'vuex-module-decorators';
const isDebug = process.env.NODE_ENV !== 'production';
export const rootStore = createStore({
    modules: {
        [filterStoreModuleName]: FilterModule,
        [fuelPurchaseModuleName]: FuelPurchaseModule,
        [messagingStoreModuleName]: MessagingModule,
        [userSettingsStoreModuleName]: UserDetailsModule,
    },
    plugins: [],
    strict: isDebug,
});
export const filterStore = getModule(FilterModule, rootStore);
export const fuelPurchaseStore = getModule(FuelPurchaseModule, rootStore);
export const messagingStore = getModule(MessagingModule, rootStore);
export const userSettingsStore = getModule(UserDetailsModule, rootStore);
